if (document.querySelector('.js-quiz')) {
  const quizBlock = document.querySelector('.quiz');
  const steps = document.querySelectorAll('.js-step');
  const lineSteps = document.querySelector('.js-lineSteps');
  const quizNext = document.querySelector('.js-quizBtn')
  const parrentQuiz = document.querySelector('.js-parentQuiz');
  const backBtn = document.querySelector('.js-backQuiz');
  const quizBtn = document.querySelector('.js-quizModalBtn');
  const quizModal = document.querySelector('.js-quizModal');
  let stepNumber = parrentQuiz.dataset.step;
  let widthStep = 100 / steps.length;

  lineSteps.style.width = `${widthStep}%`

  quizBlock.addEventListener('change', (event) => {
    const eventTar = event.target;

    if (eventTar.getAttribute('type') === 'radio') {
      document.querySelector('.quiz-btn').disabled = false;
    }
  })

  quizNext.addEventListener('click', (event) => {
    const eventTar = event.target;

    if (stepNumber < steps.length) {

      steps.forEach(elem => {
        elem.classList.remove('is-active');
      })

      document.querySelector(`#step-${Number(stepNumber) + 1}`).classList.add('is-active');

      stepNumber = `${Number(stepNumber) + 1}`;

      if (Number(stepNumber) > 1) {
        document.querySelector('.js-backQuiz').classList.remove('is-hide');
      };

      lineSteps.style.width = `${widthStep * stepNumber}%`;

      const arrRadio = document.querySelector(`#step-${stepNumber}`).querySelectorAll('.quiz-field__wrap input[type="radio"]');

      for (let input of arrRadio) {
        if (input.checked) {
          quizNext.disabled = false;
          return;
        } else {
          quizNext.disabled = true;
        }
      }

      if (stepNumber === '4') {
        document.querySelector('.quiz-block').style.display = 'none';
        document.querySelector('.js-lineStepsFinale').style.width = `${((stepNumber - 1) * widthStep)}%`
      }
    }
  })

  backBtn.addEventListener('click', (event) => {
    const eventTar = event.target;

    steps.forEach(elem => {
      elem.classList.remove('is-active');
    })

    document.querySelector(`#step-${Number(stepNumber) - 1}`).classList.add('is-active');

    stepNumber = `${Number(stepNumber) - 1}`;

    if (Number(stepNumber) < 2) {
      document.querySelector('.js-backQuiz').classList.add('is-hide');
    };

    document.querySelector(`#step-${stepNumber}`).querySelectorAll('.quiz-field__wrap input[type="radio"]').forEach(elem => {
      if (elem.checked === true) {
        quizNext.disabled = false;
      }
    })

    lineSteps.style.width = `${widthStep * stepNumber}%`
  })

  document.querySelector('.js-quizModalBtn').addEventListener('click', (event) => {
    const eventTar = event.target;

    quizModal.classList.add('is-open');
    console.log(eventTar);
  })
  document.querySelector('.js-quizModalClose').addEventListener('click', (event) => {
    const eventTar = event.target;

    quizModal.classList.remove('is-open');
  })
}
